import { gql, useMutation } from '@apollo/client';
import { RecoverLoginMutation, RecoverLoginMutationVariables } from '@/types';
import { useCallback } from 'react';

export const RECOVER_LOGIN_MUTATION = gql`
  mutation RecoverLogin(
    $accountID: String
    $businessAddress: String
    $businessName: String!
    $email: String
    $name: String!
    $phoneNumber: String
  ) {
    recoverLogin(
      account_id: $accountID
      business_address: $businessAddress
      business_name: $businessName
      email: $email
      name: $name
      phone_number: $phoneNumber
    ) {
      success
    }
  }
`;

export const useRecoverLogin = () => {
  const [recoverLogin, { loading: isSubmitting }] = useMutation<
    RecoverLoginMutation,
    RecoverLoginMutationVariables
  >(RECOVER_LOGIN_MUTATION, {
    context: {
      anonymous: true,
    },
    fetchPolicy: 'no-cache',
  });

  const recoverLoginCallback = useCallback(
    async (params: RecoverLoginMutationVariables) => {
      await recoverLogin({
        variables: params,
      });
    },
    [recoverLogin],
  );

  return { isSubmitting, recoverLoginCallback };
};
